import * as React from 'react';
import PropTypes from 'prop-types';

import { cn } from '../../libraries/tailwind/utils';
import { Link } from 'react-router-dom';
import Icon from '../renders/icon/Icon';
import ICONS from '../../enums/icons';

const Breadcrumb = React.forwardRef(
  ({ ...props }, ref) => <nav ref={ref} aria-label='breadcrumb' {...props} />
);
Breadcrumb.displayName = 'Breadcrumb';

const BreadcrumbList = React.forwardRef(({ className, ...props }, ref) => (
  <ol
    ref={ref}
    className={cn(
      'flex flex-wrap items-center break-words text-sm text-muted-foreground',
      className
    )}
    {...props} />
));
BreadcrumbList.displayName = 'BreadcrumbList';

const BreadcrumbItem = React.forwardRef(({ className, ...props }, ref) => (
  <li
    ref={ref}
    className={cn('inline-flex items-center', className)}
    {...props} />
));
BreadcrumbItem.displayName = 'BreadcrumbItem';

const BreadcrumbLink = React.forwardRef(({ className, children, ...props }, ref) => {
  return (
    (<Link
      ref={ref}
      className={cn('transition-colors hover:text-foreground', className)}
      {...props}>{children}</Link>)
  );
});
BreadcrumbLink.displayName = 'BreadcrumbLink';

const BreadcrumbPage = React.forwardRef(({ className, ...props }, ref) => (
  <a
    ref={ref}
    aria-disabled='true'
    aria-current='page'
    className={cn('text-foreground', className)}
    {...props} />
));
BreadcrumbPage.displayName = 'BreadcrumbPage';

const BreadcrumbSeparator = ({
  children,
  className,
  ...props
}) => (
  <span
    role='none'
    aria-hidden='true'
    className={cn('[&>svg]:w-3.5 [&>svg]:h-3.5 flex', className)}
    {...props}>
    {children ?? <Icon icon={ICONS.MORE_INFO} />}
  </span>
);
BreadcrumbSeparator.displayName = 'BreadcrumbSeparator';

const BreadcrumbEllipsis = ({
  className,
  ...props
}) => (
  <span
    className={cn('flex h-9 w-9 items-center justify-center', className)}
    {...props}
  >
    <Icon
      icon={ICONS.ELLIPSIS}
      aria-hidden='true'
      focusable='false'
      className='h-4 w-4'
    />
    <span className='sr-only'>More</span>
  </span>
);
BreadcrumbEllipsis.displayName = 'BreadcrumbElipssis';

BreadcrumbList.propTypes = {
  className: PropTypes.string
};

BreadcrumbItem.propTypes = {
  className: PropTypes.string
};

BreadcrumbLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

BreadcrumbPage.propTypes = {
  className: PropTypes.string
};

BreadcrumbSeparator.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

BreadcrumbEllipsis.propTypes = {
  className: PropTypes.string
};

export {
  Breadcrumb,
  BreadcrumbList,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbPage,
  BreadcrumbSeparator,
  BreadcrumbEllipsis
};